// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "软件工程",
      "tec": "史江萍",
      "week": "1-12周",
      "add": "实训楼F座101自控"
    },
    {
      "sub": "操作系统",
      "tec": "曲乐声",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "计算机网络",
      "tec": "王楚晴",
      "week": "1-12周",
      "add": "实训楼F座402信息"
    },
    {
      "sub": "移动终端技术",
      "tec": "才九荣",
      "week": "1-12周",
      "add": "教学楼B座422能动"
    },
    {
      "sub": "科技文献检索",
      "tec": "张岚",
      "week": "1-4周",
      "add": "教学楼A座125信息"
    },
    {
      "sub": "能源经济基础",
      "tec": "马铭婧",
      "week": "1-7,9周",
      "add": "教学楼B座325能动"
    },
    0
  ],
  "3": [
    {
      "sub": "软件工程",
      "tec": "史江萍",
      "week": "1-12周",
      "add": "教学楼B座417能动"
    },
    {
      "sub": "能源电力工程与绿色低碳概论",
      "tec": "崔箫董香栾",
      "week": "5-12周",
      "add": "教学楼C座404管理"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "计算机网络",
      "tec": "王楚晴",
      "week": "1-12周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "移动终端技术",
      "tec": "才九荣",
      "week": "1-12周",
      "add": "教学楼B座223自控"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "操作系统",
      "tec": "曲乐声",
      "week": "1-12周",
      "add": "教学楼B座221自控"
    },
    {
      "sub": "就业创业指导",
      "tec": "史江萍",
      "week": "1-5周",
      "add": "教学楼C座111教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
